// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPlusCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PPlusCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PPlusCircleOutlined = function PPlusCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPlusCircleOutlinedSvg
  }));
};

PPlusCircleOutlined.displayName = 'PPlusCircleOutlined';
export default React.forwardRef(PPlusCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPlusCircleOutlined.js
// module id = 3539
// module chunks = 0